import { getCategory } from './category_helper';

export const getLinkForCard = (id: string | number, type: string, slug: string, hash?: string) =>
  `/${getCategory(type).linkType}-${slug}-${id}/${hash ? `#${hash}` : ''}`;
